import React from "react";

export default function About() {
  return (
    <>
      <div className="anchor" id="about" aria-hidden="true"></div>
      <section className="about" aria-labelledby="about-heading">
        <div className="auto__container">
          <div className="about__inner">
            <div className="about__inner-title">
              <h2 id="about-heading">About</h2>
              <p>
                It's about restoring confidence, enhancing personal well-being,
                and revolutionizing the approach to hair health. Join us as we
                unveil the science, the products, and the vision that make Proxium
                a beacon of innovation and excellence in hair restoration.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
